export const ARRIVAL_ICON = "🏁";

export const DEPARTURE_LABEL = "Départ";

export const ARRIVAL_LABEL = "Arrivée";

